import React from 'react';
import { Trans } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import { IconContext } from "react-icons";
import { FaRegBellSlash } from "react-icons/fa";

const NoAlarms = props => {

  return (
    <div className="noRecords">
      <div className="logo">
        <IconContext.Provider size={ 250 } value={{ color: "rgb(45,45,60)", className: "global-class-name" }}>
          <div>
            <FaRegBellSlash />
          </div>
        </IconContext.Provider>
      </div>
      <div className="title"> <Trans>¡ No Alarms Setted !</Trans> </div>
      <div className="message">
        <p> <Trans>You have not set an alarm yet.</Trans> </p>
      </div>
      <div className="footer">
        <Button variant="success" onClick={ () => { console.log('Set Alarm'); } }> <Trans>Set Alarms</Trans> </Button>
      </div>
    </div>
  )
}

export default NoAlarms
